import maplibregl from "maplibre-gl";

// `initialView` (optional): { lon, lat, zoom }. When supplied, opens
// the map at that location/zoom — used by SketchPage so the wizard map
// inherits the address the user just picked in CreateProjectPage.
// Fallback is the previous hard-coded centre (sandbox dev default).
export function initMap(containerRef, initialView = null) {
  const center = initialView
    ? [initialView.lon, initialView.lat]
    : [8.8930775, 53.809634];
  const zoom = initialView?.zoom ?? 17;
  const map = new maplibregl.Map({
    container: containerRef.current,
    style: {
      version: 8,
      sources: {
        imagery: {
          type: "raster",
          tiles: [
            "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
          ],
          tileSize: 256
        }
      },
      layers: [
        { id: "imagery", type: "raster", source: "imagery" }
      ]
    },
    center,
    zoom,
    // 2026-07-03 Merge: maxZoom 21 kam aus PR #3 (S12, Kundenwunsch mehr
    // Zoom) — dessen MapInit-Stand hatte aber den initialView-Parameter
    // verloren (Regression: Karte öffnete immer am hartkodierten Default,
    // "Neu skizzieren" fand das Feld nie). Diese Datei vereint beide
    // Stände: initialView-Support (Mai-21) + maxZoom 21 (PR #3).
    maxZoom: 21,
    attributionControl: false,
  });
  // Dev-Sicht auf die Karte (im Produktions-Build wegkompiliert):
  // MapLibre schluckt Lade-Fehler standardmäßig lautlos — ohne das hier
  // sieht man in der Konsole nicht einmal, WARUM eine Karte grau bleibt.
  if (process.env.NODE_ENV !== "production") {
    window.__ilsMap = map;
    map.on("error", (e) => console.error("[maplibre]", e && e.error));
  }
  return map;
}
